// extracted by mini-css-extract-plugin
export default {"main":"_627d40126c _2332dd66e2","xmark":"_3702a80361","fl_img":"b9a9f2fe63 _801e4ef71e"};